if (!customElements.get('editorial-gallery')) {
  customElements.define('editorial-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true' || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          entry.target.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-in'));
          this.observer.unobserve(entry.target);
        }
      }), { threshold: 0.08 });
      this.frame = requestAnimationFrame(() => {
        // Observe the unclipped figure: a fully clipped picture has no intersection area.
        this.querySelectorAll('[data-reveal]').forEach(element => {
          const target = element.closest('.editorial-gallery__figure') || element;
          this.observer.observe(target);
        });
        this.classList.add('is-ready');
      });
      this.revealFocus = () => this.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-in'));
      this.addEventListener('focusin', this.revealFocus);
      this.addEventListener('shopify:block:select', this.revealFocus);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.removeEventListener('focusin', this.revealFocus);
      this.removeEventListener('shopify:block:select', this.revealFocus);
    }
  });
}
